(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('OrderPayModalController', OrderPayModalController);

    OrderPayModalController.$inject = ['$uibModalInstance', 'is_external', 'gross_value'];

    function OrderPayModalController($uibModalInstance, is_external, gross_value) {
        var self = this;

        self.is_external = is_external;
        self.payData = {
            partial_amount: gross_value
        };

        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close(self.payData.partial_amount);
        }

        function cancel() {
            $('.wrapper-content').removeClass('animated');
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
